export enum Action {
    join = "join",
    start = "start",
    playerJoined = "playerJoined",
    playerLeft = "playerLeft",
    hintAdded = "hintAdded",
    showHints = "showHints",
    getAllHints = "getAllHints",
    revealHints = "revealHints",
    nextTurn = "nextTurn"
};